import type { FC } from "react";
import type { DynamicMultiSelectProps } from "../../shared/DynamicMultiSelect";
import { DynamicMultiSelect } from "../../shared/DynamicMultiSelect";

export const MultiStepDynamicMultiSelect: FC<DynamicMultiSelectProps> = props => <DynamicMultiSelect {...props} />;
